import { qs } from '../lib/dom.js';
import { requireSession } from '../lib/session-guard.js';
import { mountUploadFlow } from '../lib/upload-flow.js';

await requireSession();
mountUploadFlow(qs('#flow'), {
  onSuccess: (r) => { window.location.href = `/akrabalarim.html?yuklendi=${r.recordCount}&yeni=${r.newMatches}`; },
});
